<template>
	<article class="ingredient">
		<managing-section :column-count="2">
			<managing-box title="성분명">
				<input
					v-model="params.name"
					type="text"
					@keyup.enter="searching"
				/>
			</managing-box>
			<managing-box title="EWG">
				<period-box
					mode="number"
					:use-minus="true"
					:from-value="params.ewg_min"
					:to-value="params.ewg_max"
					@change="factorEwgChange"
					@enter="searching"
				/>
			</managing-box>
			<managing-box title="항번">
				<input
					v-model="params.factor_idx"
					type="number"
					@keyup.enter="searching"
				/>
			</managing-box>
			<managing-box title="협회코드">
				<input
					v-model="params.code"
					type="text"
					@keyup.enter="searching"
				/>
			</managing-box>
		</managing-section>

		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="searching">검색하기</button>
			<button class="btn-main blue bordered" @click="init">
				검색조건 초기화
			</button>
		</div>

		<a name="main_table" ref="main_section" />
		<managing-section :is-table="true">
			<template slot="infoSection">
				<p class="section__info__left">
					등록: {{ total_count.toLocaleString() }}건
				</p>
			</template>
			<table class="table-main ingredient__list">
				<thead>
					<tr>
						<th v-for="(item, idx) in sortList" :key="idx">
							<sort-label
								v-if="typeof item === 'object'"
								:propsValue="item.value"
								:id="idx"
								:title="item.title"
								:down="item.down"
								:up="item.up"
								@change="sortImmediately"
							/>
							<template v-else>
								{{ item }}
							</template>
						</th>
					</tr>
				</thead>
				<tbody v-if="rows.length === 0">
					<tr>
						<td :colspan="sortList.length">검색결과가 없습니다.</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr
						v-for="row in rows"
						:key="row.glowpick_factor.factor_idx"
					>
						<td>
							<router-link
								:to="`/product/ingredient-management?factor-idx=${row.glowpick_factor.factor_idx}`"
								target="_blank"
								class="link"
								>{{
									row.glowpick_factor.factor_idx
								}}</router-link
							>
						</td>
						<td>{{ row.glowpick_factor.ingredient_code }}</td>
						<td>
							{{
								row.ingredient.name ||
								row.glowpick_factor.factor_korean
							}}
						</td>
						<td>
							{{
								row.ingredient.name_en ||
								row.glowpick_factor.factor_english
							}}
						</td>
						<td>
							{{ row.glowpick_factor.factor_ewg_min }}
							~
							{{ row.glowpick_factor.factor_ewg_max }}
						</td>
						<td>
							{{
								row.ingredient.purpose ||
								row.glowpick_factor.factor_purpose
							}}
						</td>
						<td>
							{{ row.glowpick_factor.use_cnt.toLocaleString() }}
						</td>
						<td>{{ row.glowpick_factor.factor_etc }}</td>
					</tr>
				</tbody>
			</table>

			<pagination-box
				slot="pagination"
				:totalItem="total_count"
				:offset="(params.page - 1) * limit"
				:limit="limit"
				@to="searching($event.offset)"
			/>
		</managing-section>
	</article>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import PeriodBox from '@/components/PeriodBox';
	import SortLabel from '@/components/product/SortLabel';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'IngredientList',
		components: {
			ManagingSection,
			ManagingBox,
			PeriodBox,
			SortLabel,
			PaginationBox,
		},
		data() {
			return {
				limit: 50,
				params: this.getDefaultParams(),
				sortList: [
					{
						value: true,
						title: '항번',
						down: null,
						up: 'factor_idx',
					},
					{
						value: null,
						title: '협회코드',
						down: 'ingredient_code-',
						up: 'ingredient_code',
					},
					{
						value: null,
						title: '한글 성분명',
						down: 'name-',
						up: 'name',
					},
					{
						value: null,
						title: '영문 성분명',
						down: 'name_en-',
						up: 'name_en',
					},
					{
						value: null,
						title: 'EWG',
						down: 'factor_ewg_min-',
						up: 'factor_ewg_min',
					},
					{
						value: null,
						title: '배합목적',
						down: 'purpose-',
						up: 'purpose',
					},
					{
						value: null,
						title: '매칭수',
						down: 'use_cnt-',
						up: 'use_cnt',
					},
					{
						value: null,
						title: '비고',
						down: 'factor_etc-',
						up: 'factor_etc',
					},
				],
				rows: [],
				total_count: 0,
			};
		},
		mounted() {
			this.getTableData();
		},
		methods: {
			getDefaultParams() {
				return {
					page: 1,
					name: null,
					factor_idx: null,
					ewg_min: null,
					ewg_max: null,
					code: null,
					sort: null,
				};
			},
			factorEwgChange({ from, to }) {
				this.params.ewg_min = from || null;
				this.params.ewg_max = to || null;
			},
			sortChange([{ newValue, id }]) {
				this.sortList = this.sortList.map((item, idx) => {
					if (typeof item === 'object') {
						item.value = null;
						if (idx === id) {
							item.value = newValue;
							this.params.sort = newValue ? item.down : item.up;
						}
					}
					return item;
				});
			},
			async getTableData() {
				const params = _.omitBy(this.params, value => !value);
				try {
					const { data } = await this.$axiosAdminJS.get(
						'/product/ingredient',
						{ params }
					);
					this.total_count = data.total_count || 0;
					this.rows = data.rows;
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					document.getElementById('admin2').scrollTop =
						this.$refs.main_section.offsetTop;
				}
			},
			searching(offset = 0) {
				this.params.page = _.isNumber(offset)
					? (offset + this.limit) / this.limit
					: 1;
				this.getTableData();
			},
			sortImmediately(arg) {
				this.sortChange(arg);
				this.searching();
			},
			init() {
				_.assign(this.params, this.getDefaultParams());
			},
		},
	};
</script>
<style lang="scss" scoped>
	.ingredient__list__ewg {
		width: 42px;
	}
</style>
